import "./OverdueTaskPanel.css";

import { ReactElement } from "react";

import { SearchWorkflowTasksResponse } from "../../service/query";
import { Column, CursorDataGrid, FlyoutPanel, Row } from "../../widget";
import { useOverdueTaskPanel } from "./useOverdueTaskPanel";

interface OverdueTaskPanelProps {
  show: boolean;
  onClose: () => void;
  setSelectedPanelTask: (task: SearchWorkflowTasksResponse["results"][0] | undefined) => void;
  setShowWorkflowTaskPanel: (show: boolean) => void;
  refreshTasks: boolean;
}

export const OverdueTaskPanel = ({
  show,
  onClose,
  setSelectedPanelTask,
  setShowWorkflowTaskPanel,
  refreshTasks,
}: OverdueTaskPanelProps): JSX.Element => {
  const { columns, defaultSortingCriteria, dataIsLoading, onChange } = useOverdueTaskPanel(
    setSelectedPanelTask,
    setShowWorkflowTaskPanel
  );

  const content = (): ReactElement => (
    <div className="OverdueTaskPanelContent">
      <div className="OverdueTaskTable">
        <Row>
          <Column span={12}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              onChange={onChange}
              sortable
              data={[]}
              refresh={refreshTasks}
              dataIsLoading={dataIsLoading}
              defaultSortingCriteria={defaultSortingCriteria}
              noDataMessage="No overdue tasks to display"
            />
          </Column>
        </Row>
      </div>
    </div>
  );

  return (
    <FlyoutPanel
      show={show}
      onClose={onClose}
      size="Large"
      header="Overdue tasks"
      contentChildren={content()}
      buttonsChildren={undefined}
    />
  );
};
